import styled, { css } from 'styled-components'

export const InfoCard = styled.div(
  ({ theme }) => css`
    background: ${theme.colors.white};
    border-radius: ${theme.border.radius['8']};
    padding: ${theme.space['24']};
    box-shadow: ${theme.shadow.sm};
  `,
)

export const InfoRow = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.space['160']};
  `,
)

export const InfoItem = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['8']};
  `,
)

export const DateTimeCell = styled.div`
  display: flex;
  flex-direction: column;
`

export const ResidentCell = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['12']};
  `,
)

export const ResidentInfo = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['2']};
    min-width: 0;
    flex: 1;
  `,
)
